type ErrorWithStatus = {
  status?: number
  reason?: string
  response?: { status?: number }
}

/**
 * A 401 from the refresh endpoint invalidates the session. A 401 from the
 * original request after refresh succeeded does not: it is an endpoint-level
 * authorization/validation failure and must not log the user out.
 */
export function shouldForceLogoutAfterRefreshError(
  error: unknown,
  originalRequestWasRetried: boolean
): boolean {
  if (originalRequestWasRetried || !error || typeof error !== 'object') return false

  const candidate = error as ErrorWithStatus
  return (
    candidate.reason === 'auth_rejected' ||
    candidate.status === 401 ||
    candidate.response?.status === 401
  )
}
